import React from "react";
import classNames from "classnames";
import styles from "./BulletList.module.scss";
import _ from "lodash";
import { Span } from "./../../";

export const PopoverBulletList = ({ liClassName, bulletClassName, ...rest }) => {
    return <BulletList liClassName={classNames(liClassName, styles['popover-li'])} bulletClassName={classNames(liClassName, styles['popover-bullet'])} {...rest}/>
}

const BulletList = ({children: _children = [], className, style, liClassName, bulletClassName, liStyle}) => {
    const children = _.isArray(_children) ? _children : [_children];
    return <ul className={classNames(styles.base, className)} style={style}>
        {children.map((child, index) => {
            return child && <li key={index} className={classNames(styles.li, liClassName)} style={liStyle}><div className={classNames(styles.bullet, bulletClassName)}/><Span>{child}</Span></li>
        })}
    </ul>
};

export default BulletList;